import { useParams } from "react-router-dom";
import {
  StockOrderHead,
  StockOrderSettingsProductEditContent,
} from "../components";

export function StockOrderingSettingsEditProductsPage() {
  const { id } = useParams();

  return (
    <>
      <StockOrderHead
        StockOrderBreadCrumbsProps={{
          home: {
            title: "Home",
            url: "/admin/material/order",
          },
          className: "lg:h-[200px]",
          pageTitles: [
            {
              name: "All Products",
              url: "/admin/material/settings/products",
            },
            {
              name: "Edit",
              url: "/admin/material/settings/products/edit/" + id,
            },
            {
              name: id,
              url: "/admin/material/settings/products/edit/" + id,
            },
          ],
        }}
      />
      <div className="p-8">
        <StockOrderSettingsProductEditContent />
      </div>
    </>
  );
}
